/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ArticleDto } from '../models/article-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des articles
 */
@Injectable({
  providedIn: 'root',
})
export class ArticlesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation articleGetList
   */
  static readonly ArticleGetListPath = '/api/articles/list';

  /**
   * Renvoie la liste des articles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ArticleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesService.ArticleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ArticleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des articles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleGetList(params?: {
  }): Observable<Array<ArticleDto>> {

    return this.articleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ArticleDto>>) => r.body as Array<ArticleDto>)
    );
  }

  /**
   * Path part for operation articleLoadList
   */
  static readonly ArticleLoadListPath = '/api/articles/load-list';

  /**
   * Renvoie la liste des articles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesService.ArticleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des articles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.articleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation articleGet
   */
  static readonly ArticleGetPath = '/api/articles/{id}';

  /**
   * Renvoie l'article spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleGet$Response(params: {

    /**
     * Identifiant de l&#x27;article
     */
    id: number;
  }): Observable<StrictHttpResponse<ArticleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesService.ArticleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ArticleDto>;
      })
    );
  }

  /**
   * Renvoie l'article spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleGet(params: {

    /**
     * Identifiant de l&#x27;article
     */
    id: number;
  }): Observable<ArticleDto> {

    return this.articleGet$Response(params).pipe(
      map((r: StrictHttpResponse<ArticleDto>) => r.body as ArticleDto)
    );
  }

  /**
   * Path part for operation articlePut
   */
  static readonly ArticlePutPath = '/api/articles/{id}';

  /**
   * Met à jour l'article spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articlePut$Response(params: {

    /**
     * Identifiant de l&#x27;article à mettre à jour
     */
    id: number;

    /**
     * Article
     */
    body: ArticleDto
  }): Observable<StrictHttpResponse<ArticleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesService.ArticlePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ArticleDto>;
      })
    );
  }

  /**
   * Met à jour l'article spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articlePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articlePut(params: {

    /**
     * Identifiant de l&#x27;article à mettre à jour
     */
    id: number;

    /**
     * Article
     */
    body: ArticleDto
  }): Observable<ArticleDto> {

    return this.articlePut$Response(params).pipe(
      map((r: StrictHttpResponse<ArticleDto>) => r.body as ArticleDto)
    );
  }

  /**
   * Path part for operation articleDelete
   */
  static readonly ArticleDeletePath = '/api/articles/{id}';

  /**
   * Supprime l'article spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleDelete$Response(params: {

    /**
     * Identifiant de l&#x27;article à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesService.ArticleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'article spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleDelete(params: {

    /**
     * Identifiant de l&#x27;article à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.articleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation articlePost
   */
  static readonly ArticlePostPath = '/api/articles';

  /**
   * Crée l'article spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articlePost$Response(params: {

    /**
     * Article
     */
    body: ArticleDto
  }): Observable<StrictHttpResponse<ArticleDto>> {

    const rb = new RequestBuilder(this.rootUrl, ArticlesService.ArticlePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ArticleDto>;
      })
    );
  }

  /**
   * Crée l'article spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `articlePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  articlePost(params: {

    /**
     * Article
     */
    body: ArticleDto
  }): Observable<ArticleDto> {

    return this.articlePost$Response(params).pipe(
      map((r: StrictHttpResponse<ArticleDto>) => r.body as ArticleDto)
    );
  }

}
